export default "__VITE_ASSET__De1kte_x__"